export default __webpack_public_path__ + "static/media/background-signal-noise-texture.b9f82d74.png";